import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Typography } from "@mui/material";
import WholesaleForm from "../Components/BookForm/WholesaleForm";
import Footer from "../Components/Footer/Footer";
import HeroWholesale from "../Assets/hero_wholesale.png";
import WholesaleBaguette from "../Assets/wholesale_baguette.png";

const Wholesale = () => {
  return (
    <>
      <Helmet>
        <title>Wholesale | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Interested in wholesale partnerships? Contact Đông Hưng Viên Bakery to discuss bulk orders and business opportunities."
        />
      </Helmet>

      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "50vh", sm: "70vh", md: "100vh" },
          backgroundImage: `url(${HeroWholesale})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "white",
          textShadow: "0px 2px 5px rgba(0, 0, 0, 0.8)",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1,
          },
        }}
      >
        <Box sx={{ position: "relative", zIndex: 2 }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "28px", sm: "40px", md: "56px" },
              mb: 2,
            }}
          >
            WHOLESALE PARTNERSHIPS
          </Typography>
        </Box>
      </Box>

      {/* Blurb Section */}
      <Box
        sx={{
          backgroundColor: "#ffffff",
          py: 6,
          textAlign: { xs: "center", md: "left" },
          color: "#333",
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            mx: "auto",
            px: 2,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: 4,
            alignItems: "center",
          }}
        >
          {/* Image on Left */}
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              order: { xs: 2, md: 1 },
            }}
          >
            <img
              src={WholesaleBaguette}
              alt="Wholesale Baguette"
              style={{
                width: "100%",
                maxWidth: "550px",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          </Box>

          {/* Text on Right */}
          <Box sx={{ order: { xs: 1, md: 2 } }}>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                lineHeight: 1.8,
              }}
            >
              At Đông Hưng Viên Bakery, we don't just bake bread - we craft the base for your best dishes. We supply local businesses with authentic Vietnamese bread, pastries, alongside a dedicated menu of vegan comfort food. Let us help you stock your kitchen with wholesome, delicious options that bring everyone to the table.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Wholesale Form */}
      <WholesaleForm />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Wholesale;